import { i18n } from '@/i18n';

import { AuthGuard } from '@/auth/auth-guards';
import type { RouteLocation, RouteRecordRaw } from 'vue-router';
import { adminRoutePaths } from '@/views/admin/admin-route-paths';
import { Permission } from '@arcual/lib-app-platform';

const { t } = i18n.global;

export const adminRoutes: Array<RouteRecordRaw> = [
  {
    meta: { title: t('platform.app.admin.title') },
    path: adminRoutePaths.ADMIN,
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_EMAILS, Permission.READ_PERMISSIONS),
    children: [
      {
        meta: { title: t('platform.app.emails.title') },
        path: adminRoutePaths.EMAILS,
        component: () => import('./emails/Emails.vue'),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_EMAILS),
      },
      {
        meta: { title: t('platform.app.userAccess.title') },
        path: adminRoutePaths.USER_ACCESS,
        component: () => import('./user-access/UserAccess.vue'),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_PERMISSIONS),
      },
    ],
  },
];
